import { render, staticRenderFns } from "./FieldType2.vue?vue&type=template&id=35838a7f&scoped=true"
import script from "./FieldType2.vue?vue&type=script&lang=js"
export * from "./FieldType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35838a7f",
  null
  
)

export default component.exports